/**
 * voice-v8 — welche Datei sich vorlesen laesst. (19.09.2026, Ticket 2395)
 *
 * Martin wollte ein Buchkapitel hoeren und fand keinen Weg dorthin. Den
 * Spieler gibt es seit pre.974 im Datei-Betrachter; der Knopf im Chat hiess
 * nur „Ansehen". Damit daneben ein „Anhoeren" stehen kann, muss die Karte
 * entscheiden, ob dort ueberhaupt etwas zu hoeren ist.
 *
 * ⚠️ Im Zweifel NEIN. Ein „Anhoeren" an einem PDF oder einem Bild waere ein
 *    Versprechen, das der Betrachter nicht haelt — und ein Knopf, der nichts
 *    tut, ist schlimmer als keiner. Deshalb eine kurze Erlaubnisliste statt
 *    einer Sperrliste: was nicht ausdruecklich Text ist, gilt als nicht
 *    vorlesbar.
 */

/** Arten, die der Betrachter als Text darstellt und vorlesen kann. */
const TEXT_ART = /^text\/(plain|markdown|x-markdown)$/i;

/** Endungen derselben Arten — fuer Dateien ohne Art-Angabe. */
const TEXT_ENDUNG = /\.(md|markdown|txt|text)$/i;

/**
 * Laesst sich diese Datei im Betrachter vorlesen?
 *
 * ⚠️ Die ART gewinnt gegen die ENDUNG. Ein PDF, das versehentlich `.md`
 *    heisst, bleibt ein PDF; die Endung ist nur der Rueckfall, wenn gar
 *    keine Art mitgeliefert wurde.
 */
export function kannVorgelesenWerden(f: {
  title?: string;
  mime?: string;
}): boolean {
  const art = (f.mime ?? "").trim().toLowerCase();
  if (art) return TEXT_ART.test(art);
  return TEXT_ENDUNG.test((f.title ?? "").trim());
}
